import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPlanListing } from "../Services/Actions/planActions";
import "../Styles/Components/PricingCards.scss";
import { useNavigate } from "react-router-dom";

const PricingCardsCall = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [selectedPlanDuration, setSelectedPlanDuration] = useState(1); // Default duration: 1 month
  const selectedCurrency = "R"; // Assume currency is ZAR
  const navigate = useNavigate();

  const handleTabChange = (path) => {
    navigate(path);
  };

  const {
    data: plansList = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["getPlanListing"],
    queryFn: () =>
      getPlanListing({
        plan_users: 1,
        currency: "ZAR",
        type: "phone",
      }),
    select: (data) => data?.data || [],
    keepPreviousData: true,
    cacheTime: 1000 * 60 * 10, // 10 minutes
    staleTime: 0, // Always stale so it refetches
    refetchOnMount: "always", // Force refetch on component mount
  });

  useEffect(() => {
    if (plansList.length > 0) {
      const filteredPlans = plansList.filter(
        (plan) => plan.planID >= 8 && plan.planID <= 11
      );
      setPlans(filteredPlans);
    } else {
      refetch(); // fallback in case data is missing
    }
  }, [plansList, refetch]);

  const onPlanSelectHandler = (plan) => {
    setSelectedPlanId(plan.planID);
  };

  if (isFetching && !plans.length) {
    return <div className="loading">Loading plans...</div>;
  }

  return (
    <div className="pricing-container">
      {plans.map((value, key) => {
        let planCost = value?.monthly_cost;
        if (selectedPlanDuration === 12) {
          planCost = value?.yearly_cost;
        } else if (selectedPlanDuration === 24) {
          planCost = value?.twoYear_cost;
        }

        const isHighlighted = key === 1; // highlight second card

        return (
          <div
            key={key}
            className={`pricing-card ${isHighlighted ? "highlighted" : ""}`}
            onClick={() => onPlanSelectHandler(value)}
          >
            <h3>{value.plan_name}</h3>
            <div className="price">
              {selectedCurrency} {planCost?.amount || "00"}
            </div>
            <div className="price-per">
              Per month (18% annual discount available)
            </div>

            <div className="best-for">
              <span>Call Minutes:</span> {` ${value.voice_minute} Minutes`}
              <br />
              <span>SMS:</span> {` ${value.sms} Business SMS`}
            </div>
            <hr />

            <ul className="feature-list">
              {[
                value.plan_name === "Start Up" && [
                  `${value.business_contacts} Business Contacts`,
                  "Instant Number",
                  `${value.cloud_storage} Cloud Storage per Host`,
                  "Basic Call (Voicemail, Caller ID, Call Forwarding)",
                  "Instant Activation (No setup required)",
                ],
                value.plan_name === "Scale Up" && [
                  "Everything in Start-Up, PLUS",
                  `${value.business_contacts} Business Contacts`,
                  "Call Forwarding To Mobile",
                  "Mobile & Web App Access",
                  "Advanced Call Routing & IVR (Auto-attendant)",
                  "Call Ratings & Agent Performance Tracking",
                ],
                value.plan_name === "Professional" && [
                  "Everything in Scale-Up, PLUS",
                  `${value.business_contacts} Business Contacts`,
                  "Appointment Scheduling",
                  `${value.cloud_storage} Cloud Storage per Host`,
                  "Mobile & Web App Access",
                  "Premium Call Features (Call Recording, Hunt Groups, Call Whisper/Barge)",
                  "CRM & Helpdesk Integration (Zoho, HubSpot, Zendesk)",
                ],
              ]
                .filter(Boolean)
                .flat()
                .map((feature, index) => (
                  <li key={index} className="feature-item">
                    <img
                      src="/assets/images/new_meet_page/check-circle.svg"
                      alt="Check"
                      className="feature-icon"
                    />
                    {feature}
                  </li>
                ))}
            </ul>

            <button
              onClick={() => handleTabChange("/signup")}
              className={`cta-button ${isHighlighted ? "highlighted" : ""}`}
            >
              {value.plan_name === "Enterprise" ? "Get a Demo" : "Try for Free"}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default PricingCardsCall;
